module.exports = __webpack_public_path__ + "img/keisi_brand_logo.647bf2ce.png";